module.exports = __webpack_public_path__ + "img/price-quote3.8635d9ab.png";